import "./TextField.css"

export const VALID_VARIANTS = [ "standard", "underlined" ]
export const VALID_TYPES = [ "text", "password" ]

function TextField(props) {
    let { icon, renderIcon, type, iconColor } = props;

    if (VALID_TYPES.indexOf(type) < 0) type = "text";

    if (renderIcon) icon = renderIcon(icon);
    else if (icon) icon = (<span className="material-icons-round yona-textField-icon" style={{ color: iconColor || "var(--yona-color-50)" }}>{icon}</span>);
    else icon = (<></>);

    props = { ...props, icon, type }

    switch (props.variant) {
        case "underlined": return underlined(props);
        default: return standard(props);
    }
}

function standard(props) {
    let { icon, placeholder, type, id } = props;

    return (<>
    
        <div className="yona-textField-wrapper">
            <input id={id} className="yona-textField-input" type={type} placeholder=" " />
            <label className="yona-textField-label">{placeholder}</label>
            {icon}
        </div>

    </>);
}

function underlined(props) {
    let { icon, placeholder, type, id } = props;
    
    return (<>
        <div className="yona-textField-wrapper">
            <input id={id} className="yona-textField-input underlined" type={type} placeholder=" " />
            <label className="yona-textField-label">{placeholder}</label>
            {icon}
        </div>
    </>);
}

export default TextField;